import { render, staticRenderFns } from "./modalKontainer.vue?vue&type=template&id=cddd67da&"
import script from "./modalKontainer.vue?vue&type=script&lang=js&"
export * from "./modalKontainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports